var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { InterrogatorActions } from '../actions/index';
export var initialState = {
    showWells: false,
    playFilter: false,
    selectedFeature: null
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case InterrogatorActions.InterrogatorActions.ToggleWells: {
            return __assign({}, state, { showWells: !state.showWells });
        }
        case InterrogatorActions.InterrogatorActions.EnablePlayFilter: {
            return __assign({}, state, { playFilter: !state.playFilter });
        }
        case InterrogatorActions.InterrogatorActions.SelectFeature: {
            return __assign({}, state, { selectedFeature: action.payload });
        }
        default:
            return state;
    }
}
